import { render, staticRenderFns } from "./TooltipBehaviorEditor.vue?vue&type=template&id=6cf4abc4&"
import script from "./TooltipBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./TooltipBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports